<template>
	<div>
		<div class="vx-row mb-2" v-for="method in paymentMethods" :key="method.slug">
			<div class="vx-col w-full">
				<vs-checkbox class="w-full" v-model="method.checked" v-on:click="updateMethod(method.slug, $event.target.checked)">{{method.label}}</vs-checkbox>
			</div>
		</div>
	</div>
</template>
<script>
	import api from '../api';
	export default {
		name: 'PaymentMethods',
		components: {},
		props: {},
		data () {
			return {
				methods: [
					{
						label: 'Ideal',
						slug: 'ideal'
					},
					{
						label: 'Creditcard (VISA, Maestro, Mastercard)',
						slug: 'creditcard'
					},
					{
						label: 'Bancontact (Mister Cash)',
						slug: 'bancontact'
					},
					{
						label: 'Sofort Banking',
						slug: 'sofort'
					},
					{
						label: 'Giropay',
						slug: 'giropay'
					}
				],
				selected: []
			}
		},
		computed: {
			paymentMethods() {
				return this.methods.map(method => {
					if (this.selected.includes(method.slug)) {
						console.log("hoi");
						method.checked = true;
					}
					return method;
				});
			}
		},
		mounted () {
			this.getDiscountRules();
		},
		methods: {
			getDiscountRules(){
				api.post("admin/settings", {keys: ['paymentMethods']}).then(response=>{
					let methods = response.data[0].value;
					this.selected = methods.filter(method => {
						return this.methods.map(method=>method.slug).includes(method);
					});
					console.log(this.selected);
				}).catch((error)=>{
					console.log(error);
				})
			},
			updateMethod(method, value){
				console.log(method, value);
				const index = this.selected.indexOf(method);
				let update = false;
				if(value && index === -1) {
					this.selected.push(method);
					update = true;
				}
				else if(!value && index !== -1) {
					update = true;
					this.selected.splice(index, 1);
				}
				if(update) {
					api.put("admin/settings", {settings: {'paymentMethods': this.selected}}).then(() => {
						this.$vs.dialog({
							title: 'Gelukt!',
							text: 'Opslaan van de discount regels is gelukt',
							color: 'success'
						})
					}).catch((error) => {
						console.log(error);
					})
				}
			},
		}
	}

</script>
